"use strict";
/* Background Image Props */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackgroundRepeat = exports.BackgroundPosition = exports.BackgroundSize = void 0;
var BackgroundSize;
(function (BackgroundSize) {
    BackgroundSize["AUTO"] = "auto";
    BackgroundSize["COVER"] = "cover";
    BackgroundSize["CONTAIN"] = "contain";
})(BackgroundSize || (exports.BackgroundSize = BackgroundSize = {}));
var BackgroundPosition;
(function (BackgroundPosition) {
    BackgroundPosition["CENTER_CENTER"] = "center center";
    BackgroundPosition["CENTER_TOP"] = "center top";
    BackgroundPosition["CENTER_BOTTOM"] = "center bottom";
    BackgroundPosition["LEFT_CENTER"] = "left center";
    BackgroundPosition["LEFT_TOP"] = "left top";
    BackgroundPosition["LEFT_BOTTOM"] = "left bottom";
    BackgroundPosition["RIGHT_CENTER"] = "right center";
    BackgroundPosition["RIGHT_TOP"] = "right top";
    BackgroundPosition["RIGHT_BOTTOM"] = "right bottom";
})(BackgroundPosition || (exports.BackgroundPosition = BackgroundPosition = {}));
var BackgroundRepeat;
(function (BackgroundRepeat) {
    BackgroundRepeat["NO_REPEAT"] = "no-repeat";
    BackgroundRepeat["REPEAT"] = "repeat";
    BackgroundRepeat["REPEAT_X"] = "repeat-x";
    BackgroundRepeat["REPEAT_Y"] = "repeat-y";
})(BackgroundRepeat || (exports.BackgroundRepeat = BackgroundRepeat = {}));
//# sourceMappingURL=enums.js.map